export default __webpack_public_path__ + "static/media/10.09e60441.jpg";